import * as Fetch from './Fetch';

export const logLevels = {
    debug: "Debug",
    error: "Error",
    info: "Info",
    trace: "Trace",
    warning: "Warning"
};

export async function log(level, message, token) {
    const url = await Fetch.getUrl("Logs/Log");
    const body = JSON.stringify({
        level: level,
        message: message
    });
    Fetch.postRequest(url, body, token);
}



// WEBPACK FOOTER //
// ./src/data/Logs.js